import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var EligibleAdyenCountriesPayoutsIA = function EligibleAdyenCountriesPayoutsIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "coXqX6",
    defaultMessage: [{
      "type": 0,
      "value": "Pour commencer à recevoir des paiements, vous devez associer un compte bancaire à votre compte Faire. Voici la marche à suivre :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "zna/Xg",
    defaultMessage: [{
      "type": 0,
      "value": "Rendez-vous dans les "
    }, {
      "children": [{
        "type": 0,
        "value": "Paramètres du compte"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "my-account");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qON8Bf",
    defaultMessage: [{
      "type": 0,
      "value": "Accédez à l'onglet "
    }, {
      "children": [{
        "type": 0,
        "value": "Paiements"
      }],
      "type": 8,
      "value": "LinkPayoutFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      LinkPayoutFormatting: function LinkPayoutFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Ngu4q0",
    defaultMessage: [{
      "type": 0,
      "value": "Cliquez sur "
    }, {
      "children": [{
        "type": 0,
        "value": "Compléter les informations de paiement"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "gTE6te",
    defaultMessage: [{
      "type": 0,
      "value": "Ensuite, vous serez redirigé vers Adyen pour terminer la configuration de votre compte."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "CSeHu8",
    defaultMessage: [{
      "type": 0,
      "value": "Vos paiements ne seront pas effectués tant que votre compte bancaire n'aura pas été vérifié par Adyen. Les paiements seront ensuite émis selon le calendrier de paiement que vous avez choisi dans les paramètres de votre compte."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};